<template>
	<div class="p-grid">

		<div class="p-col-12">			
			<div class="card">
				<Panel header="CONTROL DE CUENTAS DE USUARIOS" style="height: 100%">

				<Toolbar class="p-mb-4">
					<template v-slot:left>
						<Button label="Registrar Cuenta" icon="pi pi-plus" class="p-button-success p-mr-2" @click="openNew" />						
					</template>
					<template v-slot:right>
						<span class="p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="filters['global'].value" placeholder="Buscar..." />
                        </span>
					</template>
				</Toolbar>
				
				<DataTable :value="listaUsuarios" v-model:selection="newuserItem" class="p-datatable-gridlines" dataKey="noPlaza" :filters="filters" :rows="5" 
				style="margin-bottom: 20px" :paginator="true" responsiveLayout="scroll" :rowsPerPageOptions="[5,10,25]">				
			
				<Column field="email" header="Correo Institucional" :sortable="true" style="width:270px"></Column>
				<Column field="username" header="Nombre Usuario"></Column>
				<Column field="noPlaza" header="No. Plaza" :sortable="true" style="width:70px;text-align:center"></Column>
				<Column field="full_name" header="Nombre Completo" :sortable="true"></Column>								
				<Column style="width:170px">
					<template #header>
						Acciones
					</template>
					<template #body="slotProps">
                        <Button icon="pi pi-lock" type="button" class="p-button-success p-mr-2 p-mb-1" @click="showeditPassw(slotProps.data)"></Button>
						<Button icon="pi pi-pencil" type="button" class="p-button-success p-mr-2 p-mb-1" @click="showeditUsuarios(slotProps.data)"></Button>
                        <Button icon="pi pi-trash" type="button" class="p-button-danger p-mb-1" @click="confirmDeleteUsuarios(slotProps.data)"></Button>
					</template>
				</Column>
			</DataTable>
				
			</Panel>
			<br>
			<Toast/>

			<Dialog v-model:visible="usuarioDialog" :style="{width: '470px'}" header="Registrar Nuevo Usuario" :modal="true" class="p-fluid">
					<div class="p-field">
						<label for="name">No. Plaza:</label>
						<Dropdown id="noPlaza" v-model="newuserItem.noPlaza" :options="noplazasDocentes" autofocus optionLabel="noPlaza" required="true" placeholder="Selecciona el No. Plaza">
						<template #value="slotProps">
							<div v-if="slotProps.value && slotProps.value.value">
								<span>{{slotProps.value.noPlaza}}</span>
							</div>
							<div v-else-if="slotProps.value && !slotProps.value.value">
								<span>{{slotProps.value.noPlaza}}</span>
							</div>
							<span v-else>
								{{slotProps.placeholder}}
							</span>
						</template>
						</Dropdown>
					</div>
					<div class="p-field">
						<label for="name">Nombre Completo del Docente:</label>
						<InputText id="nom" v-model="newuserItem.fullname" required="true" :class="{'p-invalid': submitted && validarErrores.full_name}" />
						<small class="p-error" v-show="submitted && validarErrores.full_name">El nombre completo es requerido.</small>
					</div>					
					<div class="p-field">
						<label for="name">Correo Institucional:</label>
						<InputText id="tiempo"  v-model="newuserItem.email" required="true" :class="{'p-invalid': submitted && validarErrores.email}"/>
						<small class="p-error" v-show="submitted && validarErrores.email">El correo electrónico es requerido.</small>
					</div>
					<div class="p-field">
						<label for="name">Nombre de usuario:</label>
						<InputText id="nom" v-model="newuserItem.nomusuario" required="true" :class="{'p-invalid': submitted && validarErrores.nomusuario}" />
						<small class="p-error" v-show="submitted && validarErrores.nomusuario">El nombre de usuario es requerido.</small>
					</div>
					<div class="p-field">
						<label for="name">Contraseña:</label>
						<InputText id="passw" v-model="newuserItem.passwuser" required="true" :class="{'p-invalid': submitted && validarErrores.passwuser}" />
						<small class="p-error" v-show="submitted && validarErrores.passwuser">La contraseña es requerida.</small>
					</div>					
					
					<template #footer>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-danger" @click="hideDialog"/>
						<Button label="Guardar " icon="pi pi-check" class="p-button-primary" @click="saveUsuario" />
					</template>
			</Dialog>

			<Dialog v-model:visible="editarDialog" :style="{width: '470px'}" header="Editar Cuenta de Usuario" :modal="true" class="p-fluid">					
					<div class="p-field">
						<label for="name">No. Plaza:</label>
						<Dropdown id="noPlaza" v-model="newuserItem.noPlaza" :options="noplazasDocentes" autofocus optionLabel="noPlaza" required="true" placeholder="Selecciona el No. Plaza">
						<template #value="slotProps">
							<div v-if="slotProps.value && slotProps.value.value">
								<span>{{slotProps.value.noPlaza}}</span>
							</div>
							<div v-else-if="slotProps.value && !slotProps.value.value">
								<span>{{slotProps.value.noPlaza}}</span>
							</div>
							<span v-else>
								{{slotProps.placeholder}}
							</span>
						</template>
						</Dropdown>
					</div>
					<div class="p-field">
						<label for="name">Nombre Completo del Docente:</label>
						<InputText id="nom" v-model="newuserItem.full_name" required="true" :class="{'p-invalid': submitted && validarErrores.full_name}" />
						<small class="p-error" v-show="submitted && validarErrores.full_name">El nombre completo es requerido.</small>
					</div>					
					<div class="p-field">
						<label for="name">Correo Institucional:</label>
						<InputText id="tiempo"  v-model="newuserItem.email" required="true" :class="{'p-invalid': submitted && validarErrores.email}"/>
						<small class="p-error" v-show="submitted && validarErrores.email">El nombre de la Institución es requerido.</small>
					</div>
					<div class="p-field">
						<label for="name">Nombre de usuario:</label>
						<InputText id="nom" v-model="newuserItem.periodoCursado" required="true" :class="{'p-invalid': submitted && validarErrores.periodoCursado}" />
						<small class="p-error" v-show="submitted && validarErrores.periodoCursado">El periodo cursado es requerido.</small>
					</div>	
					<div class="p-field">
						<label for="name">Contraseña:</label>
						<InputText id="passw" v-model="newuserItem.passwuser" required="true" :class="{'p-invalid': submitted && validarErrores.passwuser}" />
						<small class="p-error" v-show="submitted && validarErrores.passwuser">La contraseña es requerida.</small>
					</div>				
					
					<template #footer>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-danger" @click="hideDialogEditar"/>
						<Button label="Editar " icon="pi pi-check" class="p-button-primary" @click="editUsuario" />
					</template>
			</Dialog>

			<Dialog v-model:visible="editarPasswDialog" :style="{width: '470px'}" header="Editar Contraseña Usuario" :modal="true" class="p-fluid">										
					<div class="p-field">
						<label for="name">Nombre de usuario:</label>
						<InputText id="nom" v-model="newuserItem.fullname" readonly/>						
					</div>
					<div class="p-field">
						<label for="name">Escribe la nueva Contraseña:</label>
						<InputText id="nom" v-model="newuserItem.passwuser" required="true" autofocus :class="{'p-invalid': submitted && validarErrores.passwuser}" />
						<small class="p-error" v-show="submitted && validarErrores.passwuser">La nueva contraseña es requerida.</small>
					</div>	
					
					<template #footer>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-danger" @click="editarPasswDialog = false"/>
						<Button label="Editar " icon="pi pi-check" class="p-button-primary" @click="editPassword" />
					</template>
			</Dialog>


			<Dialog v-model:visible="deleteUsuarioDialog" :style="{width: '450px'}" header="Confirmar eliminación" :modal="true">
					<div class="confirmation-content">
						<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
						<span>¿ Deseas eliminar el Usuario seleccionado ?</span>
					</div>
					<template #footer>
						<Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteUsuarioDialog = false"/>
						<Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteUsuario" />
					</template>
			</Dialog>

			</div>			
		</div>
	</div>
</template>
<script>
import apiUserAdmin from '@/service/AuthUserService';
import { FilterMatchMode } from 'primevue/api';

export default {
		data() {
				return{
					listaUsuarios: [],
					noplazasDocentes:[],
					newuserItem: {
						noPlaza: null,
						email: null,
						nomusuario:null,
						fullname:null,
						passwuser:null
					},					
					usuarioDialog: false,
					editarDialog: false,
					editarPasswDialog: false,
					deleteUsuarioDialog: false,
					filters: [{
							'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
					}],									
					validarErrores: {},
					submitted: false
				}
		},		
		created() {
			this.initialize();
			this.initFilters();
		},
		mounted() {
			this.readUsers();
			this.readPlazas();
		},
		methods: {
			initialize () {
			this.readUsers();
			this.readPlazas();
			}, 
			readUsers: async function() {   
				const data = await apiUserAdmin.readUsers();  
				this.listaUsuarios = data;
			},
			readPlazas: async function() {   
				const data = await apiUserAdmin.readNoPlazas();  				
				this.noplazasDocentes = data;				
			},	
			insertUsuario: async function() { 
				const requestData = {					   
					noplaza: this.newuserItem.noPlaza.noPlaza,
					full_name: this.newuserItem.fullname,
					email: this.newuserItem.email,
					username: this.newuserItem.nomusuario,					
					password: this.newuserItem.passwuser			
				};
				
				await apiUserAdmin.createUser(requestData); //Insertar el item mediante API REST     
				this.newuserItem.noPlaza = "";
				this.newuserItem.email = "";
				this.newuserItem.nomusuario = "";
				this.newuserItem.fullname = "";	
				this.newuserItem.passwuser = "";			
				this.readUsers();
				this.$toast.add({severity:'success', summary: 'Confirmación', detail: 'Cuenta de Usuario registrada', life: 3000});
			},	
			updateUsuario: async function() { 
				const requestData = {
					noplaza: this.newuserItem.noPlaza.noPlaza,
					email: this.newuserItem.email,
					username: this.newuserItem.nomusuario,
					full_name: this.newuserItem.fullname	
				};
				
				await apiUserAdmin.updateUser(this.newuserItem.noPlaza,requestData); 
				this.newuserItem.noPlaza = "";
				this.newuserItem.email = "";
				this.newuserItem.nomusuario = "";
				this.newuserItem.fullname = "";	
				this.readUsers();
				this.$toast.add({severity:'success', summary: 'Confirmación', detail: 'Cuenta de Usuario modificada', life: 3000});
			},
			updatePassword: async function() { 
				const requestData = {					
					password: this.newuserItem.passwuser	
				};
				
				await apiUserAdmin.updatePassword(this.newuserItem.noPlaza,requestData); 
				this.newuserItem.passwuser = "";				
				this.readUsers();
				this.$toast.add({severity:'success', summary: 'Confirmación', detail: 'La contraseña ha sido modificada', life: 3000});
			},
			deleteUsuario: async function() {
				await apiUserAdmin.deleteUser(this.newuserItem.noPlaza);								
				this.readUsers();
				this.deleteUsuarioDialog = false;						
				this.$toast.add({severity:'success', summary: 'Acción correcta', detail: 'Cuenta de Usuario eliminada', life: 3000});
			},
			openNew() {	
				this.submitted = false;
				this.newuserItem={
					noPlaza:'',
					email:'',
					nomusuario:'',
					fullname:'',
					passwuser:''
				}
				this.usuarioDialog = true;
			},
			hideDialog() {
				this.usuarioDialog = false;
				this.submitted = false;
			},
			hideDialogEditar() {
				this.editarDialog = false;
				this.submitted = false;
			},
			initFilters() {
            this.filters = {
				'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
				}
			},
			saveUsuario() {
				this.submitted = true;
				if (this.validarForm() ) {				
					this.insertUsuario();
					this.hideDialog();
				}
			},
			editUsuario() {
				this.submitted = true;
				if (this.validarForm() ) {				
					this.updateUsuario();
					this.hideDialogEditar();
				}
			},
			editPassword() {
				this.updatePassword();
				this.editarPasswDialog = false;
			},
			validarForm() {
				
				if (!this.newuserItem.email.trim())
					this.validarErrores['email'] = true;
				else
					delete this.validarErrores['email'];
				
				if (!this.newuserItem.nomusuario.trim())
					this.validarErrores['nomusuario'] = true;
				else
					delete this.validarErrores['nomusuario'];
				
				if (!this.newuserItem.fullname.trim())
					this.validarErrores['full_name'] = true;
				else
					delete this.validarErrores['full_name'];
				
				if (!this.newuserItem.passwuser.trim())
					this.validarErrores['passwuser'] = true;
				else
					delete this.validarErrores['passwuser'];

				return !Object.keys(this.validarErrores).length;
			},		
			confirmDeleteUsuarios(user) {				
				this.newuserItem.idGrado = user.noPlaza;				
				this.deleteUsuarioDialog = true;				
			},
			showeditUsuarios(userdata) {
				//Son los valores de los campos del Datatable
				this.newuserItem={
					noPlaza: userdata.noPlaza,
					email: userdata.email,
					nomusuario: userdata.nomusuario,
					fullname: userdata.full_name
				} 
				this.editarDialog = true;				
			},
			showeditPassw(userdata) {
				//Son los valores de los campos del Datatable
				this.newuserItem={
					fullname: userdata.full_name,
					noPlaza: userdata.noPlaza,
					passwuser:''
				} 
				this.editarPasswDialog = true;				
			}
		}
	}
</script>

<style scoped lang="scss">
	.table-header {
		display: flex;
		justify-content: space-between;
	}
</style>
